/**
 * Utility to resolve asset URLs.
 * If the URL is relative (starts with /uploads), it prepends the server URL.
 */
export const getAssetUrl = (url) => {
    if (!url || typeof url !== 'string') return "";
    
    // Normalize url
    const cleanUrl = url.trim();
    
    const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:8000/api';
    const serverUrl = baseUrl.replace('/api', '').replace(/\/$/, '');

    // Handle full URLs
    if (cleanUrl.startsWith("http")) {
        // Replace localhost with current server URL if found
        if (cleanUrl.includes("localhost")) {
            return cleanUrl.replace(/https?:\/\/localhost:\d+/, serverUrl);
        }
        return cleanUrl;
    }
    
    // Handle relative paths
    if (cleanUrl.startsWith("/uploads")) {
        return `${serverUrl}${cleanUrl}`;
    }

    if (cleanUrl.startsWith("uploads/")) {
        return `${serverUrl}/${cleanUrl}`;
    }
    
    return cleanUrl;
};
